import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { UserService } from '../../users-module/services/user.service';
import { ScreeningService } from '../services/screening.service';
import { ClientService } from '../../clients-module/services/client.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { ScreeningFilter, OrderByDesignator, ScreeningOrderByContract } from '../../models/ScreeningFilter';
import { FilterDataType, SimpleDataFilter } from 'src/app/models/simpleDataFilter';
import { PaginationEventData } from 'src/app/shared-components-module/pagination-top/models/paginationEventData';
import { FilteringService } from 'src/app/services/filtering.service';
import { ScreeningDraftService } from '../services/screening-draft.service';
import { PaginationService } from 'src/app/shared-components-module/pagination-top/services/pagination.service';


@Component({
  selector: 'app-screenings-module',
  templateUrl: './screenings-module.component.html',
  styleUrls: ['./screenings-module.component.less']
})
export class ScreeningsModuleComponent implements AfterViewInit,OnDestroy {
  ngOnDestroy(): void {
    this.filtering.filters = [];
  }

  showScreeningDrafts: boolean = false;
  public displayFilters = true;
  constructor(public auth: AuthService,
              public users: UserService,
              public screening: ScreeningService,
              public clients: ClientService,
              public toast: ToastrService,
              public location: Router,
              public drafts : ScreeningDraftService,
              public filtering : FilteringService,
              public pagination : PaginationService,
              public activatedRoute: ActivatedRoute) {
                if(this.drafts.directOrderDemographics) this.drafts.directOrderDemographics = undefined;
  }


  public ngAfterViewInit(): void {
    // attach a keypress listener if the user presses enter, the filters will be applied
    document.getElementById('filterPanel').addEventListener('keypress', (e) => {
      if (e.key === 'Enter') {
        this.applyFilters();
      }
    });
  }

  showDrafts(): void {
    this.showScreeningDrafts = !this.showScreeningDrafts;
  }

  public applyFilters(): void {

    // Clear the array otherwise since the array is a Singleton it will just add them into it
    this.filtering.filters = [];
    this.screening.screenings = [];
    this.screening.FetchFilteredScreeningsList()
  }

  public clearFilters(): void {
    this.screening.screeningFilter = new ScreeningFilter();
    this.screening.orderBy = new ScreeningOrderByContract();
    this.screening.screenings = [];
    this.filtering.filters = [];
    this.screening.orderBy.orderByColumn = undefined;
    this.screening.orderBy.designator = undefined;
    console.log(this.screening.orderBy);
    // this.screening.FetchUnFilteredScreeningsList(0,this.pagination.pageIncrement)
    this.screening.FetchFilteredScreeningsList(this.pagination.pageIncrement,0);
  }

  public showFilters(): void {
    this.displayFilters = !this.displayFilters;
  }

  public update(val: any) {
    this.screening.screeningFilter[val.property] = val.time;
  }

  public onPaginationChanged(event: PaginationEventData) {
    // this.filtering.filters.push(new SimpleDataFilter('offsetCount', event.offset.toString(), true));
    this.screening.screenings = [];
    this.screening.FetchFilteredScreeningsList();
    this.filtering.clearTransientFilters();
  }

  public refetch()
  {
      console.warn('refetch trigger')
      this.screening.FetchFilteredScreeningsList();
  }
}
